import { render, staticRenderFns } from "./BidModifiersBadge.vue?vue&type=template&id=78366b76&scoped=true"
import script from "./BidModifiersBadge.vue?vue&type=script&lang=js"
export * from "./BidModifiersBadge.vue?vue&type=script&lang=js"
import style0 from "./BidModifiersBadge.vue?vue&type=style&index=0&id=78366b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78366b76",
  null
  
)

export default component.exports